import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { ConfirmationModal } from 'components';
import { useHistoryBlock } from 'helpers/hooks';

const RouterPrompt = ({ when, CancelButtonProps, ConfirmButtonProps, ...props }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [blockedPathname, setBlockedPathname] = useState('');

  const [unblockRef] = useHistoryBlock({
    when,
    onBlock: ({ pathname } = {}) => {
      setOpen(true);
      setBlockedPathname(pathname);
    },
  });

  const onClose = () => setOpen(false);

  const onConfirm = () => {
    unblockRef.current?.();
    setOpen(false);
    history.push(blockedPathname || '/opportunities/recommended');
  };

  return (
    <ConfirmationModal
      {...props}
      open={open}
      onClose={onClose}
      CancelButtonProps={{ onClick: onClose, ...CancelButtonProps }}
      ConfirmButtonProps={{ onClick: onConfirm, ...ConfirmButtonProps }}
    />
  );
};

export default RouterPrompt;
